<template>
  <div>
    <b-dropdown
      ref="dropdownPredefine"
      aria-role="menu"
      expanded
      append-to-body
      :close-on-click="false"
    >
      <template #trigger>
        <div
          class="date-input-wrapper is-clickable px-2 flex-center-vertical is-justify-content-space-between is-relative"
        >
          <div class="flex-center c-h-100">
            <ScheduleIcon width="15" height="15" />
            <p class="ml-2 color-black-primary">{{ selectedLabel }}</p>
          </div>

          <div v-if="selectedPredefine" class="close-wrapper ml-2" @click="clearSelected">
            <XMarkIcon size="10" color="#000" />
          </div>
        </div>
      </template>

      <div class="date-report-progress-wrapper bg-white p-4">
        <div class="predefine-wrapper">
          <div
            v-for="(item, index) in listPredefine"
            :key="index"
            class="btn-predefine is-clickable flex-center py-2 mb-3"
            :class="{ active: selectedValue === item.value }"
            @click="handleClickPredefine(item)"
          >
            <p
              class="label-14 averta-reguler"
              :class="{
                'averta-bold color-red': selectedValue === item.value
              }"
            >
              {{ item.title }}
            </p>
          </div>
          <div class="flex-center mt-4">
            <ButtonApp
              :isSecondary="true"
              @click="closeDropdown({ isReset: true })"
              class="flex-1 mr-3"
            >
              <p class="averta-bold py-2">Batalkan</p>
            </ButtonApp>
            <ButtonApp class="flex-1" @click="submitPredefine">
              <p class="averta-bold py-2">Pilih</p>
            </ButtonApp>
          </div>
        </div>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DropdownPredefine',
  props: {
    placeholder: {
      type: String,
      default: 'Pilih Tanggal'
    }
  },
  components: {
    ScheduleIcon: () => import('@/components/icons/ScheduleIcon'),
    XMarkIcon: () => import('@/components/icons/XMarkIcon'),
    ButtonApp: () => import('@/components/button/ButtonApp')
  },
  data () {
    return {
      selectedPredefine: null,
      tempSelectedPredefine: null,
      listPredefine: [
        {
          title: 'Sepanjang Waktu',
          value: 'all-time',
          start_date: null,
          end_date: null
        },
        {
          title: '3 Bulan',
          value: '3-month',
          start_date: moment().format('YYYY-MM-DD'),
          end_date: moment().subtract(3, 'months').format('YYYY-MM-DD')
        },
        {
          title: '6 Bulan',
          value: '6-month',
          start_date: moment().format('YYYY-MM-DD'),
          end_date: moment().subtract(6, 'months').format('YYYY-MM-DD')
        },
        {
          title: '1 Tahun',
          value: '1-year',
          start_date: moment().format('YYYY-MM-DD'),
          end_date: moment().subtract(1, 'year').format('YYYY-MM-DD')
        }
      ]
    }
  },
  computed: {
    selectedLabel () {
      return this.selectedPredefine ? this.selectedPredefine.title : this.placeholder
    },
    selectedValue () {
      return this.tempSelectedPredefine ? this.tempSelectedPredefine.value : null
    }
  },
  methods: {
    handleClickPredefine (value) {
      this.tempSelectedPredefine = value
    },
    clearSelected () {
      this.selectedPredefine = null
    },
    closeDropdown () {
      this.selectedPredefine = null
      this.$refs.dropdownPredefine.toggle()
      this.$emit('selected', { data: null, type: 'summary', reset: true })
      window.location.reload()
    },
    submitPredefine () {
      this.selectedPredefine = this.tempSelectedPredefine
      this.$refs.dropdownPredefine.toggle()
      this.$emit('selected', { data: this.selectedPredefine, type: 'summary' })
    },
    handlePageRefresh () {
      localStorage.setItem('report_summary', JSON.stringify(this.selectedPredefine))
    }
  },
  mounted () {
    const temp = localStorage.getItem('report_summary')
    if (temp) {
      this.selectedPredefine = JSON.parse(temp)
      this.tempSelectedPredefine = JSON.parse(temp)
    }
  },
  created () {
    window.addEventListener('beforeunload', this.handlePageRefresh)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handlePageRefresh)
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.date-input-wrapper {
  border: 1px solid $color-grey-2;
  border-radius: 12px;
  overflow: hidden;
  min-width: 14em;
  height: 2.65em;
}

.predefine-wrapper {
  width: 15em;
}

.date-report-progress-wrapper {
  position: absolute;
  right: 0;
  z-index: 5;
  display: flex;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  border-radius: 12px;
  border: 1px solid $color-grey-2;
}

.btn-predefine {
  border-radius: 100px;
  border: 1px solid $color-grey-2;
  background: $color-white;
  transition: 0.05s all ease-in-out;
}

.btn-predefine.active {
  border: 1px solid $color-red-1;
  background: $color-pink-2;
}
</style>
